import { moodleInstanceApi } from "./moodleInstanceApi";
import { AxiosError } from "axios";
import { handleApiError } from "./instanceApi";

export const getTotalGrade = async (userid:any, courseid:any) => {
    try{
        const response = await moodleInstanceApi.get(
            "/webservice/rest/server.php",
            {
                params: {
                    wsfunction: "gradereport_user_get_grade_items",
                    courseid: courseid,
                    userid: userid,
                }
            }
        );
        return response?.data;
    } catch (error) {
        return handleApiError(error as AxiosError);
    }
}

export const getGradeTable = async (userid:any, courseid:any) => {
    try{
        const response = await moodleInstanceApi.get(
            "/webservice/rest/server.php",
            {
                params: {
                    wsfunction: "gradereport_user_get_grades_table",
                    courseid: courseid,
                    userid: userid,
                }
            }
        );
        return response?.data;
    } catch (error) {
        return handleApiError(error as AxiosError);
    }
}
